import { CONCIERGE_KEY } from './utils';

// Step components
import ReasonComponent from './components/Reason/Reason';
import ContactComponent from './components/Contact/Contact';

// Step objects
export const Reason = {
  name: CONCIERGE_KEY.REASON,
  path: 'reason',
  component: ReasonComponent,
};

export const Contact = {
  name: CONCIERGE_KEY.CONTACT,
  path: 'contact',
  component: ContactComponent,
};
